import React from 'react'
import { useNavigate } from 'react-router-dom'
import { HiPlus } from 'react-icons/hi'
import { Button } from 'flowbite-react'
import { useAuth } from '../contexts/AuthContext'
import AuthorityAutocomplete from '../components/AuthorityAutocomplete'

const CityAdmin = () => {
  const navigate = useNavigate()
  const { token } = useAuth()

  const handleSelect = (item) => {
    navigate(`/city-admin/${item.id}`)
  }

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              City Administration
            </h1>
            <p className="text-gray-600 dark:text-gray-300">
              Search cities, manage profiles, and review related leads.
            </p>
          </div>
          <Button onClick={() => navigate('/city-admin/new')}>
            <HiPlus className="h-4 w-4 mr-2" />
            Add City
          </Button>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <AuthorityAutocomplete token={token} onSelect={handleSelect} autoFocus />
      </div>
    </div>
  )
}

export default CityAdmin
